module.exports = __webpack_public_path__ + "img/logo.1265ec3e.png";